import { useLocation } from "react-router";

export const useIsPreview = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return {
    isPreview:
      params.get("preview") === "true" ||
      (!!window.UC?.integrations?.commerce.moduleApiUrl &&
        document.referrer.startsWith(
          window.UC?.integrations?.commerce.moduleApiUrl
        )),
  };
};
